import { CreateModal } from "./CreateModal"
import { CreateOrEditModal } from "./CreateOrEditModal";

export const MODALS = {
  createSavedViewModal: CreateModal,
  createOrEditSavedViewModal: CreateOrEditModal,
};
